// Shared by the junior and senior onboarding screens: showing one person's onboarding record.

export const progressViewOf = (row) => ({
  progress: row || null,
  notes: row?.notes || "",
  blockers: row?.blockers || "",
  notesDirty: false,
});

// Loads one person's record. The previous person's record is cleared first and again if the load fails, so
// the page can never show (or save over) somebody else's ticks and notes under this person's name.
// Answers for a person the manager has already moved away from are ignored (triage FE-06-23).
export async function loadProgressView({ fetchRow, isCurrent, show, onStart, onFail, onDone }) {
  show(progressViewOf(null));
  onStart();
  try {
    const row = await fetchRow();
    if (isCurrent()) show(progressViewOf(row));
  } catch (err) {
    if (isCurrent()) {
      show(progressViewOf(null));
      onFail(err);
    }
  } finally {
    if (isCurrent()) onDone();
  }
}

// A tick or stage change shows at once, then is saved. If the save fails, the screen goes back to what it
// showed before, so a failed save never looks done (triage FE-06-25).
export async function saveOptimistically({ progress, patch, setProgress, save, onFail }) {
  const before = {};
  for (const key of Object.keys(patch)) before[key] = progress[key];
  setProgress((p) => ({ ...p, ...patch }));
  try {
    setProgress(await save());
  } catch (err) {
    setProgress((p) => ({ ...p, ...before }));
    onFail(err);
  }
}
